import {message, Space, Skeleton} from "antd";
import {useGetProductContext} from "../context/get-product";
import {ProductCoverImagesFormFields} from "../../../../components/offering-form/products/cover-images";
import {useProductUploadCoverImages} from "../../../../react-query-hooks/products/upload-content";
import {useProductCoverImagesDelete} from "../../../../features/media";
import {useFormContext} from "react-hook-form";
import {EditProductBasicFormStepFormValues} from "../schema-validation";
import {FormFieldError} from "../../../../design-system/form-field";
import {
  useCoverImagesWithFallback,
  mapDomainToEmbedded,
} from "../../../../features/media";

export function EditProductCoverImagesUpload() {
  const {
    state: {productData},
  } = useGetProductContext();
  const {setValue, watch, formState} =
    useFormContext<EditProductBasicFormStepFormValues>();
  const productUploadCoverImagesMutation = useProductUploadCoverImages();
  const productCoverImagesDeleteMutation = useProductCoverImagesDelete();

  // Fetch cover images via v2 with fallback to embedded data
  const {coverImages, isLoading: isCoverImagesLoading} = useCoverImagesWithFallback({
    offeringType: "product",
    offeringId: productData.product.id,
    embedded: productData.product.cover_images,
  });

  // Convert domain format back to API format for existing component
  const coverImagesForDisplay = mapDomainToEmbedded(coverImages);

  function handleCoverImagesItemDelete({
    mediaId,
    offeringId,
  }: {
    mediaId: string;
    offeringId: number;
  }) {
    productCoverImagesDeleteMutation.mutate(
      {mediaId, productId: offeringId},
      {
        onSuccess: () => {
          const currentCoverImages = watch("cover_images");

          const newValues = currentCoverImages.filter((x) => x.id !== mediaId);
          // console.log({currentCoverImages, newValues});
          setValue("cover_images", newValues);
          message.success("Deleted successfully");
        },
      }
    );
  }

  // Show loading skeleton while fetching cover images
  if (isCoverImagesLoading) {
    return (
      <div>
        <Space size={16} direction="vertical" style={{display: "flex"}}>
          <Skeleton.Image active style={{width: 200, height: 120}} />
        </Space>
      </div>
    );
  }

  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <ProductCoverImagesFormFields
          accordionIndex={0}
          productData={{
            id: productData.product.id,
          }}
          defaultCoverImages={coverImagesForDisplay}
          deleteCoverImage={handleCoverImagesItemDelete}
          isDeleteLoading={productCoverImagesDeleteMutation.isLoading}
          isUploadLoading={productUploadCoverImagesMutation.isLoading}
          offeringId={productData.product.id}
          uploadCoverImages={productUploadCoverImagesMutation}
        />
        <FormFieldError errorMessage={formState.errors.cover_images?.message} />
      </Space>
    </div>
  );
}
